const topics = [
  { tag: '暗夜追踪第二季', count: '582万', color: 'primary' },
  { tag: '西瓜视频免费', count: '496万', color: 'accent' },
  { tag: '丝瓜视频高清', count: '428万', color: 'secondary' },
  { tag: '欢乐喜剧人', count: '389万', color: 'primary' },
  { tag: '仙道至尊', count: '367万', color: 'accent' },
  { tag: '电影大全推荐', count: '312万', color: 'secondary' },
  { tag: '高清不缓冲', count: '289万', color: 'primary' },
  { tag: '最新电视剧', count: '254万', color: 'accent' },
  { tag: '经典港片', count: '218万', color: 'secondary' },
  { tag: '动漫追番', count: '195万', color: 'primary' },
];

const colorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700 hover:bg-primary-200',
  accent: 'bg-accent-100 text-accent-700 hover:bg-accent-200',
  secondary: 'bg-secondary-100 text-secondary-700 hover:bg-secondary-200',
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            大家都在讨论的影视话题，看看哪些内容最受关注
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-[900px] mx-auto">
          {topics.map((topic, i) => (
            <a
              key={i}
              href="#carousel"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium transition-colors duration-200 cursor-pointer no-underline ${colorMap[topic.color]}`}
            >
              <span>#{topic.tag}</span>
              <span className="text-xs opacity-70">{topic.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}